module.exports = __webpack_public_path__ + "img/page.b1ffebd6.png";